<script setup>

</script>

<template>
  <svg width="25" height="19" viewBox="0 0 25 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M18.6 0.0996091L12.5 6.19961L6.4 0.0996086L-2.75382e-07 6.39961L12.5 18.8996L25 6.39961L18.6 0.0996091Z" fill="#376FFE"/>
  </svg>
</template>

<style scoped lang="scss">

</style>
